export default {
  bind(el, binding, vnode) {
    const that = vnode.context
    const selectWrap_dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    selectWrap_dom.addEventListener('scroll', function () {
      // 判断是否滚动到底部
      const condition = this.scrollHeight - this.scrollTop <= this.clientHeight
      if (condition) {
        /**
         * binding.value 是指令的绑定值，该值可能是字符串，数字、函数
         * binding.value() 表示执行 v-loadmore 绑定的函数
         */
        that[binding.arg](binding.value)
      }
    })
  },
}
